import { cloneElement } from 'react';
import classNames from 'classnames/bind';

import { GridLayout, GridLayoutItem } from 'components/grid/GridLayout';
import { H1 } from 'components/heading/Heading';
import { PictureProps } from 'components/picture/Picture';

import { FormProps } from '../form-elements/Form';

import s from './FormLayout.module.scss';

const c = classNames.bind(s);

export type FormLayoutProps = {
  title?: string;
  content?: React.ReactElement;
  children?: React.ReactElement<FormProps>;
  columns?: boolean;
  image?: React.ReactElement<PictureProps>;
  formSubmitted?: boolean;
  successMessage?: React.ReactElement;
};

export const FormLayout = ({
  title,
  content,
  children,
  columns,
  image,
  formSubmitted,
  successMessage,
}: FormLayoutProps) => {
  const formColumns = image
    ? { tablet: 10, desktop: 5, wide: 4 }
    : { tablet: 10, wide: 8 };
  const formOffset = image
    ? { desktop: 6, wide: 7, tablet: 1 }
    : { desktop: 0, wide: 0, tablet: 1 };

  return (
    <GridLayout className={c(s.formLayout, { hasImage: image, formSubmitted })}>
      {image && (
        <GridLayoutItem
          columns={{ desktop: 5, wide: 6 }}
          className={s.formLayout__imageWrap}
        >
          {cloneElement(image, { className: s.formLayout__image })}
        </GridLayoutItem>
      )}
      <GridLayoutItem
        className={s.formLayout__formWrap}
        columns={formColumns}
        offset={formOffset}
      >
        {(title || content) && (
          <div className={s.formLayout__content}>
            {title && <H1>{title}</H1>}
            <div className={s.formLayout__text}>{!formSubmitted && content}</div>
          </div>
        )}

        <div className={s.formLayout__inner}>
          {formSubmitted && <div className={s.formLayout__success}>{successMessage}</div>}
          {children && (
            <div className={s.formLayout__form}>
              {cloneElement(children, { columns: columns && !image })}
            </div>
          )}
        </div>
      </GridLayoutItem>
    </GridLayout>
  );
};
